import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import "./Assets/Styles/global.scss";
import "./Assets/Styles/responsive.scss";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { DataProvider } from './Components/DataContext.js';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <DataProvider>
    <App />
  </DataProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

